import Glide from "@glidejs/glide";

window.Partnerships = {
    init() {
        this.initGlide();
    },

    initGlide() {
        var partnershipGlide = new Glide('.partnership-glide', {
            type: 'carousel',
            perView: 4,
            focusAt: 'center',
            breakpoints: {
                800: {
                    perView: 2
                },
                640: {
                    perView: 1
                }
            }
        })


        partnershipGlide.mount();
    }
};
